(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/components/sport/analyze/assets/constants.js') >= 0) return;  svs.modules.push('/components/sport/analyze/assets/constants.js');
"use strict";


const linkType = {
  INTERNAL: 'internal',
  EXTERNAL: 'external'
};
setGlobal('svs.component.analyze.constants', {
  linkType
});

 })(window);